import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { registerUserProspectRequest } from './RegisterProspectAPI';
import { RegisterProps } from '../../Models/RegisterProps';

// Define a type for the slice state
interface CounterState {
  isFetching: boolean;
  status: 'IDLE' | 'PENDING' | 'SUCCESS' | 'FAILED' | 'OTP_PENDING';
  error: any;
  sessionDetails: {
    buddyName: string;
    buddyUrl: null | string;
    defaultReplyTime: string;
    prospectId: string;
    sessionId: string;
    prospectNeedsToValidated: boolean;
  };
}

// Define the initial state using that type
const initialState: CounterState = {
  isFetching: false,
  status: 'IDLE',
  error: {},
  sessionDetails: {
    buddyName: '',
    buddyUrl: '',
    defaultReplyTime: '',
    prospectId: '',
    sessionId: '',
    prospectNeedsToValidated: false,
  },
};

export const registerProspectUser = createAsyncThunk('prospect/register', async (userDetails: RegisterProps) => {
  return await registerUserProspectRequest(userDetails);
});

// Then, handle actions in your reducers:
const registerProspectSlice = createSlice({
  name: 'prospectRegister',
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearRegisterProspects: (state) => {
      state.isFetching = false;
      state.status = 'IDLE';
      state.sessionDetails = {
        buddyName: '',
        buddyUrl: '',
        defaultReplyTime: '',
        prospectId: '',
        sessionId: '',
        prospectNeedsToValidated: false,
      };
    },
    setRegisterSuccessAfterOTPValidate: (state) => {
      state.status = 'SUCCESS';
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(registerProspectUser.pending, (state) => {
        state.status = 'PENDING';
        state.isFetching = true;
      })
      .addCase(registerProspectUser.fulfilled, (state, action) => {
        // Add user to the state array
        // state.status = action.payload.prospectNeedsToValidated ? 'OTP_PENDING' : 'SUCCESS';
        state.status = 'SUCCESS';
        state.isFetching = false;
        state.sessionDetails = action.payload;
        localStorage.setItem('sessionDetails', JSON.stringify(action.payload));
      })
      .addCase(registerProspectUser.rejected, (state, reason) => {
        state.status = 'FAILED';
        state.isFetching = false;
        state.error = reason.error;
        localStorage.removeItem('sessionDetails');
      });
  },
});

export const registerProspectSelector = (state: RootState) => state.registerProspects;

export const { clearRegisterProspects, setRegisterSuccessAfterOTPValidate } = registerProspectSlice.actions;
export default registerProspectSlice.reducer;
